import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ShowManualDataProvider } from "./helpers/SwitchTab_Context";
import Script_Manager from "./common/Script_Manager";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ShowManualDataProvider>
        <ToastContainer />
        <Script_Manager>
          <App />
        </Script_Manager>
      </ShowManualDataProvider>
    </Provider>
  </BrowserRouter>
);
reportWebVitals();
